import api from '../utils/api';

// Interface matching backend response
interface BackendDocument {
  id: string;
  filename: string;
  file_path: string | null;
  url: string | null;
  documents_metadata: any | null;
  created_at: string;
}

// Interface for frontend use
interface Document {
  id: string;
  name: string;
  uploadedAt: string;
  file_path?: string | null;
  url?: string | null;
  tag?: string | null;
}

interface DocumentsResponse {
  documents: Document[];
  total: number;
}

class DocumentService {
  async getIngestedDocuments(): Promise<DocumentsResponse> {
    try {
      const response = await api.get<BackendDocument[]>('/api/get-ingested-documents');

      // Map backend response to frontend format
      const documents: Document[] = (response.data || []).map((doc: BackendDocument) => {
        const tag = doc.documents_metadata?.TAG ||
                    doc.documents_metadata?.tag ||
                    doc.documents_metadata?.fund ||
                    null;

        return {
          id: doc.id,
          name: doc.filename,
          uploadedAt: doc.created_at,
          file_path: doc.file_path,
          url: doc.url,
          tag
        };
      });

      return {
        documents,
        total: documents.length
      };
    } catch (error) {
      console.error('Error fetching ingested documents:', error);
      throw error;
    }
  }

  async getDocumentFile(fileId: string): Promise<Blob> {
    try {
      const response = await api.get(`/api/get-ingested-documents/file/${fileId}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching document file:', error);
      throw error;
    }
  }

  async viewDocumentFile(fileId: string): Promise<string> {
    try {
      const blob = await this.getDocumentFile(fileId);
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error viewing document file:', error);
      throw error;
    }
  }

  async downloadDocumentFile(fileId: string, fileName: string): Promise<void> {
    try {
      const blob = await this.getDocumentFile(fileId);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading document file:', error);
      throw error;
    }
  }
}

export const documentService = new DocumentService();
export type { Document, DocumentsResponse };